import { post } from "./requests";
import { parse } from "../helpers/parser";
import { getElement } from "../helpers/htmlHelper";

export async function getPage(...params){
        const resp = await post(...params);

        if(resp && resp.result){
            return parse(resp.result);
        }   
}

export async function getTable(...params){
    const page = await getPage(...params);
    const table = getElement(page, '.table_box');
    return table;
}

export async function getTableForDate(params) {
    const date = new Date(params);

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    const table = await getTable(day, month, year);

    return table;
}
